// Moderação de username:
// - RESERVED_FIRST_NAMES: nomes próprios brasileiros muito comuns. Match exato
//   (após normalizar acentos) bloqueia para evitar que a primeira pessoa
//   "ana" reserve o handle. O usuário deve adicionar sufixo ou número.
// - BANNED_SUBSTRINGS: termos vetados em qualquer parte do username
//   (substring match em lowercase). Lista a ser revisada por humano
//   periodicamente.

export const RESERVED_FIRST_NAMES: string[] = [
  // masculinos
  'andre', 'fernando', 'joao', 'pedro', 'paulo', 'lucas', 'gabriel',
  'rafael', 'bruno', 'mateus', 'matheus', 'daniel', 'felipe', 'rodrigo',
  'eduardo', 'marcelo', 'ricardo', 'leonardo', 'carlos', 'antonio',
  'jose', 'marcos', 'vinicius', 'gustavo', 'henrique', 'diego', 'leandro',
  'fabio', 'juliano', 'alex', 'victor', 'vitor', 'hugo', 'igor', 'raul',
  'sergio', 'tiago', 'thiago', 'marcio', 'roberto', 'renato', 'cesar',
  'guilherme', 'arthur', 'davi', 'samuel', 'enzo', 'bernardo', 'miguel',
  'heitor', 'theo', 'noah', 'caua', 'isaac', 'erick', 'caio',
  'breno', 'otavio', 'francisco', 'jorge', 'jonas', 'william', 'wesley',
  'wallace', 'douglas', 'edson', 'edgar', 'evandro', 'fabricio', 'flavio',
  'cristiano', 'cleber', 'claudio', 'wagner', 'walter', 'alberto', 'alvaro',
  'aldo', 'alfredo', 'alessandro', 'amauri', 'anderson', 'angelo', 'augusto',
  'aurelio', 'benedito', 'cassio', 'celso', 'clovis', 'daniel', 'dario',
  'denis', 'dionisio', 'edmilson', 'elias', 'emerson', 'enrico', 'erico',
  'estevao', 'fabiano', 'fagner', 'fausto', 'fred', 'geraldo', 'gilberto',
  'giovanni', 'helio', 'humberto', 'idelfonso', 'ismael', 'ivan', 'jeronimo',
  'joaquim', 'jonatas', 'jorge', 'kevin', 'kleber', 'lazaro', 'lucio',
  'luis', 'luiz', 'marcio', 'mario', 'mauricio', 'mauro', 'nelson',
  'nilson', 'odair', 'orlando', 'osvaldo', 'oswaldo', 'pablo', 'patrick',
  'reinaldo', 'rene', 'romario', 'romulo', 'ronaldo', 'ruan', 'ruben',
  'sebastiao', 'silvio', 'sandro', 'tadeu', 'thales', 'ulisses', 'valdir',
  'valter', 'vicente', 'waldemar', 'wesley', 'wilson', 'yuri', 'zeca',
  // femininos
  'ana', 'maria', 'julia', 'mariana', 'beatriz', 'larissa', 'leticia',
  'amanda', 'fernanda', 'juliana', 'camila', 'gabriela', 'rafaela',
  'bianca', 'bruna', 'isabela', 'isadora', 'sofia', 'sophia', 'alice',
  'valentina', 'helena', 'laura', 'manuela', 'livia', 'lara', 'clara',
  'cecilia', 'eduarda', 'isabelle', 'lais', 'paula', 'patricia', 'simone',
  'sandra', 'claudia', 'monica', 'vanessa', 'debora', 'renata', 'viviane',
  'fabiana', 'raquel', 'rosa', 'rosana', 'eliane', 'marcia', 'regina',
  'sonia', 'silvia', 'lucia', 'miriam', 'marisa', 'jaqueline', 'joana',
  'jennifer', 'michele', 'kelly', 'sabrina', 'denise', 'daniele', 'priscila',
  'carolina', 'carla', 'cintia', 'cristiane', 'andrea', 'adriana',
  'tatiana', 'tatiane', 'aline', 'alessandra', 'caroline', 'erika',
  'elaine', 'elisa', 'natalia', 'natasha', 'nathalia', 'vera', 'wanda',
  'yasmin', 'yara', 'elena', 'olivia', 'antonia', 'francisca', 'aparecida',
  'agatha', 'agnes', 'aida', 'alana', 'alicia', 'aline', 'alma', 'amalia',
  'angela', 'antonella', 'aurora', 'bárbara', 'barbara', 'belinda', 'bella',
  'berta', 'betina', 'cassia', 'catarina', 'catia', 'celia', 'cibele',
  'cida', 'cleide', 'clenia', 'consuelo', 'dalva', 'diana', 'dolores',
  'dora', 'elaine', 'eliana', 'elis', 'elza', 'emilia', 'esmeralda',
  'eva', 'fatima', 'gisele', 'gloria', 'graca', 'helga', 'ingrid', 'iolanda',
  'irene', 'iris', 'ivone', 'janaina', 'janete', 'jessica', 'joice',
  'josefa', 'judite', 'karen', 'karina', 'lais', 'liana', 'lidia',
  'liliana', 'lorena', 'luana', 'luciana', 'luisa', 'lurdes', 'magda',
  'magna', 'malena', 'malu', 'manuela', 'margarida', 'marina', 'marisol',
  'marta', 'milena', 'myrian', 'nadia', 'naiara', 'nair', 'neide',
  'neusa', 'nicole', 'noemia', 'odete', 'palmira', 'penelope', 'rafaela',
  'rita', 'roberta', 'rosangela', 'roseli', 'rute', 'salete', 'samanta',
  'samantha', 'sara', 'selma', 'severina', 'shirley', 'solange', 'stela',
  'suely', 'taina', 'tamara', 'tania', 'teresa', 'thais', 'valeria',
  'verena', 'vilma', 'virginia', 'vitoria', 'wendy', 'zelia', 'zilda',
];

export const BANNED_SUBSTRINGS: string[] = [
  // racial
  'nigga', 'nigger', 'preto_lixo', 'macaco_preto',
  // antissemitismo / nazismo
  'hitler', 'nazi', 'nazista', 'nazism', 'jewkiller', 'jew_killer',
  'auschwitz', 'holocausto_fake',
  // homofobia
  'viado', 'viadinho', 'bichinha', 'sapatao', 'traveco',
  // capacitismo
  'retardado', 'retard', 'mongoloide', 'mongol_idiota',
  // palavrões pesados
  'puta', 'putaria', 'caralho', 'porra', 'foda_se',
  // genérico/ofensivo (impersonação de equipe)
  'admin', 'support', 'oficial', 'boratrocar', 'moderador',
];

export type UsernameValidation =
  | { ok: true }
  | {
      ok: false;
      reason: 'too_short' | 'too_long' | 'invalid_chars' | 'reserved_name' | 'banned_word';
    };

const VALID_RE = /^[a-z0-9_]+$/;

function stripAccents(input: string): string {
  return input.normalize('NFD').replace(/[̀-ͯ]/g, '');
}

const RESERVED_SET = new Set(RESERVED_FIRST_NAMES.map((n) => stripAccents(n.toLowerCase())));

export function validateUsername(raw: string): UsernameValidation {
  const value = (raw || '').toLowerCase();

  if (value.length < 4) return { ok: false, reason: 'too_short' };
  if (value.length > 20) return { ok: false, reason: 'too_long' };
  if (!VALID_RE.test(value)) return { ok: false, reason: 'invalid_chars' };

  const normalized = stripAccents(value);
  if (RESERVED_SET.has(normalized)) return { ok: false, reason: 'reserved_name' };

  for (const term of BANNED_SUBSTRINGS) {
    if (value.includes(term)) return { ok: false, reason: 'banned_word' };
  }

  return { ok: true };
}
